import { CodeNameModel } from 'components/common/types';
import { Advertiser, Brand } from 'components/common/types/Deal.types';
import { PublisherCampaignRequiredFieldsConfig } from 'components/common/types/Publisher.types';
import {
  DirectSalesLineObjective,
  DirectSalesCampaignLevelFields,
} from 'components/common/types/DirectSalesCampaign.types';

export const getNewObjectiveId = (objectives: DirectSalesLineObjective[]): number => {
  if (!objectives.length) return 1;
  const currentMaxId = Math.max(...objectives.map((objective) => objective.objectiveGroupId));

  return currentMaxId + 1;
};

export const getUniqueObjectiveName = (objectives: DirectSalesLineObjective[], idx: number): string => {
  const existingObjectivesNames = objectives.map(({ name }) => name.toLowerCase());
  const newObjectiveName = `Objective ${idx}`;

  if (!existingObjectivesNames.includes(newObjectiveName.toLowerCase())) return newObjectiveName;

  return getUniqueObjectiveName(objectives, idx + 1);
};

export const ceilHour = (date: Date): Date => {
  if (date.getMinutes() > 0 || date.getSeconds() > 0) date.setHours(date.getHours() + 1, 0, 0, 0);
  else date.setHours(date.getHours(), 0, 0, 0);

  return date;
};

export const getDirectSalesMandatoryCampaignFields = ({
  fieldsConfig,
  ...fields
}: {
  fieldsConfig?: PublisherCampaignRequiredFieldsConfig;
  advertiser: Advertiser | null;
  brand: Brand | null;
  productCategory: CodeNameModel | null;
  salesPerson: CodeNameModel | null;
  salesTeam: CodeNameModel | null;
  adminPerson?: CodeNameModel | null;
}): DirectSalesCampaignLevelFields => {
  const defaultMandatoryCriteria = {
    advertiser: fields.advertiser,
    brand: fields.brand,
    productCategory: fields.productCategory,
  } as DirectSalesCampaignLevelFields;

  if (!fieldsConfig) {
    return defaultMandatoryCriteria;
  }

  const mandatoryFieldsCriteria = Object.fromEntries(
    fieldsConfig.campaign.filter((key) => key in fields).map((key) => [key, fields[key as keyof typeof fields]]),
  );

  return {
    ...mandatoryFieldsCriteria,
  };
};
